<template>
  <div>
    <ModalDelete v-bind="{ mediaItemId }" v-on="{ deleted: removeCampaignMediaItemId }" />
  </div>
</template>

<script>
import { campaignMediaComputed, campaignMediaMethods } from '@/store/helper';
import { middleware } from '@/routes/guards';
import ModalDelete from '@/components/Media/ModalDelete.vue';

export default {
  name: 'MediaDelete',
  components: {
    ModalDelete,
  },
  props: {
    mediaItemId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...campaignMediaComputed,
  },
  beforeRouteEnter: middleware('account-permission:delete media'),
  methods: {
    ...campaignMediaMethods,
    removeCampaignMediaItemId(mediaItemId) {
      this.setIds([...this.ids.filter((id) => id !== mediaItemId)]);
    },
  },
};
</script>
